export enum ProjectedTargetTimeEnum {
  COMPLETION_TIME = 'COMPLETION_TIME',
  PROJECTED_DROP_OFF_TIME = 'PROJECTED_DROP_OFF_TIME',
  PROJECTED_LAST_LOAD_TIME = 'PROJECTED_LAST_LOAD_TIME',
}
